// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Transportserviceforindustries() {



const cardData = {


    keyword: "Transportation Services for Industrial",

    headingDescription: "SSK Logistic provides structured transportation services for industrial businesses that require dependable movement of machinery, factory materials, heavy equipment, industrial cargo, manufacturing goods, containers, ODC consignments, and other specialized shipments. Industrial transportation often involves larger dimensions, higher weights, specific loading requirements, and carefully planned delivery routes, so each movement can be coordinated according to cargo characteristics, vehicle capacity, pickup conditions, and destination requirements. From Pune's manufacturing belts and industrial estates to major commercial and production centers across India, SSK Logistic supports businesses with practical road transportation and logistics coordination for regular as well as project-based industrial cargo movement.",

    topPlaces: [
        {
            title: "Pimpri-Chinchwad",
            description: "Pimpri-Chinchwad is a major manufacturing and engineering belt with continuous movement of machinery, components, raw materials, finished products, and industrial equipment. SSK Logistic supports transportation requirements in this region with suitable vehicle coordination based on cargo size, weight, loading conditions, and destination."
        },
        {
            title: "Pune to Vadodara",
            description: "Pune to Vadodara connects two important industrial markets with strong manufacturing and engineering activity. SSK Logistic coordinates industrial cargo movement between these locations for machinery, factory materials, equipment, components, and larger commercial consignments requiring planned interstate road transportation."
        },
        {
            title: "Jejuri",
            description: "Jejuri and its surrounding industrial areas contribute to Pune's manufacturing and production network. SSK Logistic assists businesses moving machinery, raw materials, fabricated components, factory supplies, and finished industrial goods from Pune toward this region with suitable transportation planning."
        },
        {
            title: "Pune to Bengaluru",
            description: "Pune to Bengaluru is an important industrial corridor connecting manufacturing, engineering, automotive, electronics, and commercial operations across two major business regions. SSK Logistic supports long-distance transportation of machinery, industrial materials, components, equipment, and factory consignments."
        },
        {
            title: "Satara",
            description: "Satara has a growing industrial and manufacturing ecosystem requiring movement of raw materials, equipment, finished goods, and commercial supplies. SSK Logistic provides transportation coordination between Pune and Satara for businesses requiring suitable vehicles and organized industrial cargo movement."
        },
        {
            title: "Pune to Rajkot",
            description: "Rajkot is a prominent engineering and manufacturing center in Gujarat with requirements for machinery, components, metal products, and industrial materials. SSK Logistic supports Pune businesses with road transportation toward Rajkot for heavy, commercial, and industrial consignments."
        },
        {
            title: "Khed City",
            description: "Khed City represents an important industrial destination near Pune with manufacturing and business operations requiring regular cargo movement. SSK Logistic coordinates transportation for factory materials, machinery, components, production supplies, and finished goods according to shipment and vehicle requirements."
        },
        {
            title: "Pune to Hyderabad",
            description: "Pune to Hyderabad provides a significant interstate route for industrial businesses moving equipment, components, machinery, production materials, and finished goods. SSK Logistic coordinates suitable road vehicles and long-distance transportation arrangements according to cargo dimensions and delivery requirements."
        },
        {
            title: "Shirwal",
            description: "Shirwal is connected with manufacturing and industrial activity along the Pune-Satara corridor. SSK Logistic supports businesses transporting factory supplies, machinery, raw materials, components, and finished products between Pune and Shirwal with practical road transportation planning."
        },
        {
            title: "Pune to Chennai",
            description: "Pune to Chennai is a major long-distance industrial route connecting manufacturing and engineering markets in western and southern India. SSK Logistic supports transportation of machinery, industrial components, heavy materials, factory equipment, and larger consignments with planned interstate road movement."
        }
    ],

    "services": [
        {
            "name": "industrial transportation services",
            "description": "SSK Logistic provides industrial transportation services for manufacturers, factories, engineering companies, warehouses, and industrial suppliers moving machinery, raw materials, equipment, components, and finished products. Vehicle and route planning can be coordinated around cargo dimensions, weight, loading requirements, and destination conditions."
        },
        {
            "name": "industrial transport services pune",
            "description": "Industrial transport services pune support businesses operating across manufacturing zones and industrial estates around Pune. SSK Logistic coordinates road transportation for factory materials, equipment, machinery, production supplies, and commercial industrial cargo according to vehicle capacity and route requirements."
        },
        {
            "name": "industrial goods transportation",
            "description": "Industrial goods transportation involves moving raw materials, machinery components, finished products, tools, equipment, and production supplies between factories, suppliers, and warehouses. SSK Logistic organizes suitable transportation arrangements according to shipment volume, cargo characteristics, and delivery destination."
        },
        {
            "name": "industrial logistics services pune",
            "description": "SSK Logistic supports industrial logistics services pune with transportation coordination for manufacturing units, engineering businesses, warehouses, and industrial suppliers. Services can cover regular cargo movement, factory transfers, equipment transportation, raw material dispatches, and larger industrial shipments."
        },
        {
            "name": "industrial transport company pune",
            "description": "Businesses searching for an industrial transport company pune can coordinate machinery, materials, equipment, components, and finished goods transportation with SSK Logistic. Transportation planning takes into account vehicle suitability, cargo dimensions, loading conditions, route distance, and delivery requirements."
        },
        {
            "name": "industrial cargo transportation pune",
            "description": "Industrial cargo transportation pune requires suitable vehicles and organized handling for different types of manufacturing and factory consignments. SSK Logistic coordinates road transportation for industrial equipment, raw materials, machinery, components, and bulk cargo based on shipment requirements."
        },
        {
            "name": "industrial freight transportation pune",
            "description": "SSK Logistic provides industrial freight transportation pune for businesses moving larger consignments between factories, warehouses, suppliers, and commercial destinations. Freight arrangements can be coordinated for local Maharashtra routes as well as interstate industrial corridors."
        },
        {
            "name": "heavy equipment transportation pune",
            "description": "Heavy equipment transportation pune requires careful planning around weight, dimensions, loading methods, vehicle capacity, and route conditions. SSK Logistic supports transportation requirements for industrial equipment, production machinery, engineering units, plant components, and other substantial loads."
        },
        {
            "name": "heavy goods transport pune",
            "description": "SSK Logistic coordinates heavy goods transport pune for industrial businesses moving large machinery, equipment, materials, and substantial commercial consignments. Transportation arrangements can be planned according to cargo weight, dimensions, loading requirements, and destination accessibility."
        },
        {
            "name": "machinery transportation services pune",
            "description": "Machinery transportation services pune are suitable for manufacturers and industrial businesses relocating or dispatching production equipment, machines, engineering units, and factory components. SSK Logistic coordinates appropriate road transportation according to machinery size, weight, loading requirements, and route distance."
        },
        {
            "name": "factory goods transportation pune",
            "description": "Factory goods transportation pune supports movement of raw materials, production components, finished products, packaging materials, equipment, and factory supplies. SSK Logistic helps coordinate suitable vehicles and delivery arrangements for manufacturers and industrial units operating around Pune."
        },
        {
            "name": "manufacturing transportation services pune",
            "description": "Manufacturing transportation services pune help production businesses move materials and finished goods between suppliers, factories, warehouses, and customers. SSK Logistic coordinates road transportation based on cargo type, shipment volume, vehicle capacity, route requirements, and operational schedules."
        },
        {
            "name": "industrial material transportation pune",
            "description": "Industrial material transportation pune covers the movement of raw materials, fabricated parts, production supplies, components, tools, and other factory-related goods. SSK Logistic plans transportation according to material quantity, cargo dimensions, loading conditions, and the required delivery location."
        },
        {
            "name": "full truck load industrial transport",
            "description": "Full truck load industrial transport is suitable when a manufacturing or industrial shipment requires dedicated vehicle capacity. SSK Logistic coordinates FTL transportation for machinery, bulk materials, factory inventory, finished goods, and larger consignments across local and interstate routes."
        },
        {
            "name": "container transportation for industries",
            "description": "Container transportation for industries provides a practical option for moving larger industrial consignments between factories, warehouses, suppliers, and distribution locations. SSK Logistic coordinates suitable road transportation according to container requirements, cargo characteristics, route distance, and delivery conditions."
        },
        {
            "name": "ODC transportation services pune",
            "description": "ODC transportation services pune require specialized planning for consignments that exceed standard dimensions or involve unusual cargo configurations. SSK Logistic coordinates transportation requirements by considering cargo dimensions, weight, vehicle suitability, route conditions, loading arrangements, and destination access."
        },
        {
            "name": "industrial logistics company pune",
            "description": "SSK Logistic supports businesses looking for an industrial logistics company pune for coordinated transportation of machinery, materials, equipment, components, and factory goods. Logistics planning can be structured around pickup points, vehicle requirements, route distance, cargo characteristics, and delivery schedules."
        },
        {
            "name": "industrial supply chain services",
            "description": "Industrial supply chain services depend on timely movement of raw materials, production components, finished products, and inventory between different operational locations. SSK Logistic supports the transportation side of these supply chains through organized road cargo movement and vehicle coordination."
        },
        {
            "name": "safe industrial transportation",
            "description": "Safe industrial transportation requires suitable vehicles, appropriate loading arrangements, route planning, and careful coordination for heavy or specialized cargo. SSK Logistic structures transportation according to the weight, dimensions, type, and destination of each industrial shipment."
        },
        {
            "name": "reliable industrial transport pune",
            "description": "Businesses requiring reliable industrial transport pune can coordinate recurring and one-time cargo movements with SSK Logistic. Transportation arrangements can support factory materials, machinery, components, equipment, finished products, and industrial inventory across suitable local and interstate routes."
        },
        {
            "name": "commercial industrial transportation",
            "description": "Commercial industrial transportation supports businesses that need to move factory goods, equipment, inventory, raw materials, and finished products between commercial and industrial locations. SSK Logistic coordinates road vehicles according to shipment volume, cargo type, destination, and delivery requirements."
        },
        {
            "name": "specialized industrial transport",
            "description": "Specialized industrial transport is required for machinery, oversized equipment, heavy components, and consignments with specific handling or vehicle requirements. SSK Logistic coordinates transportation based on cargo dimensions, weight, loading method, route conditions, and destination access."
        },
        {
            "name": "heavy cargo transportation pune",
            "description": "Heavy cargo transportation pune requires detailed consideration of vehicle capacity, cargo weight, dimensions, loading arrangements, and route planning. SSK Logistic supports movement of industrial machinery, large equipment, factory materials, and other heavy commercial consignments."
        },
        {
            "name": "industrial freight services pune",
            "description": "Industrial freight services pune from SSK Logistic support manufacturers and industrial businesses moving cargo between factories, warehouses, suppliers, and commercial destinations. Freight transportation can be arranged for machinery, materials, components, finished goods, and larger industrial consignments."
        },
        {
            "name": "industrial transport solutions pune",
            "description": "Industrial transport solutions pune can be coordinated by SSK Logistic for businesses with different cargo sizes, route distances, and vehicle requirements. From regular factory deliveries to heavy machinery and interstate freight, transportation planning is adapted to the operational needs of each shipment."
        }
    ],

    "tableData": [
        ["industrial transportation services", "industrial transport services pune"],
        ["industrial goods transportation", "industrial logistics services pune"],
        ["industrial transport company pune", "industrial cargo transportation pune"],
        ["industrial freight transportation pune", "heavy equipment transportation pune"],
        ["heavy goods transport pune", "machinery transportation services pune"],
        ["factory goods transportation pune", "manufacturing transportation services pune"],
        ["industrial material transportation pune", "full truck load industrial transport"],
        ["container transportation for industries", "ODC transportation services pune"],
        ["industrial logistics company pune", "industrial supply chain services"],
        ["safe industrial transportation", "reliable industrial transport pune"],
        ["commercial industrial transportation", "specialized industrial transport"],
        ["heavy cargo transportation pune", "industrial freight services pune"],
        ["industrial transport solutions pune", "Transportation Services for Industrial"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Built Around Industrial Cargo Requirements",
            WhyChoosedescription: "Industrial shipments can vary significantly in weight, dimensions, material type, and loading requirements. SSK Logistic coordinates transportation after considering these practical factors so manufacturers and factories can arrange suitable road movement for their cargo."
        },
        {
            WhyChooseheading: "Heavy Equipment Movement",
            WhyChoosedescription: "Large machinery and industrial equipment require more detailed transportation planning than ordinary commercial goods. SSK Logistic supports heavy cargo requirements with vehicle and route coordination based on equipment dimensions, weight, loading conditions, and destination access."
        },
        {
            WhyChooseheading: "ODC and Specialized Cargo Coordination",
            WhyChoosedescription: "Oversized and specialized industrial consignments may require specific transportation arrangements. SSK Logistic coordinates ODC and specialized cargo movements by considering shipment measurements, vehicle suitability, route requirements, loading arrangements, and delivery conditions."
        },
        {
            WhyChooseheading: "Manufacturing Corridor Connectivity",
            WhyChoosedescription: "Pune is surrounded by important manufacturing and industrial zones such as Pimpri-Chinchwad, Chakan, Ranjangaon, Talegaon, Khed, and other production centers. SSK Logistic supports transportation between these locations and wider interstate industrial markets."
        },
        {
            WhyChooseheading: "Full Truck Load Support",
            WhyChoosedescription: "Industrial businesses with substantial cargo volumes may require dedicated truck capacity rather than shared transportation. SSK Logistic coordinates full truck load movement for machinery, factory materials, equipment, finished products, and bulk industrial consignments."
        },
        {
            WhyChooseheading: "Interstate Industrial Transportation",
            WhyChoosedescription: "Manufacturing supply chains often extend beyond the local market. SSK Logistic supports industrial road transportation from Pune toward destinations across Maharashtra and other states, including Gujarat, Karnataka, Telangana, Tamil Nadu, Rajasthan, and central Indian markets."
        },
        {
            WhyChooseheading: "Practical Loading and Route Planning",
            WhyChoosedescription: "Industrial cargo movement depends on more than simply selecting a vehicle. SSK Logistic coordinates transportation with attention to pickup access, loading requirements, cargo dimensions, route distance, vehicle capacity, and destination conditions for better-organized movement."
        },
        {
            WhyChooseheading: "Suitable for Regular Factory Movement",
            WhyChoosedescription: "Factories and manufacturers may have recurring requirements for raw material deliveries, component transfers, finished product dispatches, and warehouse movement. SSK Logistic supports these operational transportation needs with arrangements that can be coordinated around individual shipment schedules."
        }
    ]

};













const faqData = [
    {
        question: "What industrial transportation services does SSK Logistic provide?",
        answer: "SSK Logistic supports industrial businesses with transportation for machinery, equipment, raw materials, finished products, commercial stock, and other suitable industrial consignments from Pune to different destinations."
    },
    {
        question: "Can SSK Logistic transport industrial goods from Pune to other cities?",
        answer: "Industrial cargo can be coordinated from Pune toward destinations such as Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, and other cities according to the shipment requirements."
    },
    {
        question: "What types of industrial materials can SSK Logistic transport?",
        answer: "Depending on the cargo specifications and vehicle requirements, transportation can be arranged for machinery, production materials, equipment, industrial supplies, packaged goods, components, finished products, and other suitable business consignments."
    },
    {
        question: "Can SSK Logistic support recurring industrial transportation requirements?",
        answer: "Manufacturing and industrial companies with regular goods movement can discuss recurring transportation arrangements based on their shipment frequency, routes, cargo volume, vehicle capacity, and delivery schedules."
    },
    {
        question: "How does SSK Logistic select a vehicle for industrial cargo?",
        answer: "The transportation vehicle is planned according to factors such as cargo weight, dimensions, quantity, loading method, equipment requirements, route distance, destination, and the characteristics of the industrial material."
    },
    {
        question: "Can SSK Logistic arrange industrial transportation from Pune to Mumbai?",
        answer: "Yes, industrial materials, machinery, equipment, supplies, commercial stock, and other suitable cargo can be transported between Pune and Mumbai based on the shipment details and required vehicle."
    },
    {
        question: "Does SSK Logistic provide industrial transportation to destinations outside Maharashtra?",
        answer: "Interstate industrial goods movement can be coordinated from Pune toward Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other regions based on route feasibility and cargo requirements."
    },
    {
        question: "Can manufacturers use SSK Logistic for transporting raw materials and finished goods?",
        answer: "Manufacturers can utilize transportation support for moving suitable raw materials, finished products, machinery, equipment, production supplies, and commercial inventory between factories, warehouses, suppliers, and destinations."
    },
    {
        question: "Can industrial transportation be customized according to cargo requirements?",
        answer: "Transportation planning can be adjusted around the pickup location, destination, cargo specifications, weight, dimensions, loading requirements, vehicle capacity, delivery timeframe, and frequency of industrial shipments."
    },
    {
        question: "What details are needed to arrange industrial transportation with SSK Logistic?",
        answer: "Businesses can provide the pickup point, delivery destination, material type, approximate weight and dimensions, quantity, loading requirements, preferred vehicle, and expected delivery schedule to discuss a suitable transportation arrangement."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Mahesh Thorat",
        feedback: "Our manufacturing unit required transportation for production equipment from Pune to Nagpur. SSK Logistic reviewed the shipment details and coordinated the vehicle according to our industrial cargo requirements.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Komal Joshi",
        feedback: "We regularly move industrial materials between our Pune facility and another location. SSK Logistic has been convenient to coordinate with, especially when sharing cargo quantity and vehicle requirements for each movement.",
        rating: 5
    }
];














    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Transportation Services for Industrial",
  "image": "https://ssklogistics.in/assets/images/transportation-services-for-industrial.webp",
  "description": "SSK Logistics provides Transportation Services for Industrial requirements involving the planned movement of industrial goods, machinery, equipment, raw materials, commercial cargo and heavy consignments. Industrial transportation services can support manufacturers, engineering companies, factories, distributors and industrial businesses that require dependable movement of materials between plants, warehouses, project locations and commercial destinations. Industrial transport services Pune are coordinated around cargo type, load requirements, route distance and delivery schedules, while industrial goods transportation can cover machinery, production materials, packaged industrial products, equipment and other business consignments. As an industrial logistics services Pune provider, SSK Logistics assists with transportation planning, vehicle coordination and shipment movement for regular as well as project-based requirements. Industrial transport company Pune requirements may include local distribution, Maharashtra routes and interstate goods movement, while industrial cargo transportation Pune and industrial freight transportation Pune can be arranged according to the size and nature of the consignment. Heavy equipment transportation Pune and heavy goods transport Pune require appropriate vehicle selection and route planning, particularly when handling large, bulky or high-weight materials. SSK Logistics focuses on practical transportation coordination for industrial businesses seeking organized cargo movement, responsive communication and flexible logistics support.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/transportation-services-for-industrial"
  }
};



    return (
        <div>
<Helmet>
  <title>
    Transportation Services for Industrial | Heavy Goods, Cargo & Equipment Transport Pune | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics offers industrial transportation services in Pune for heavy goods, industrial cargo, equipment, machinery, freight and commercial materials with coordinated vehicle and route planning."
  />

  <meta
    name="keywords"
    content="Transportation Services for Industrial, industrial transportation services, industrial transport services Pune, industrial goods transportation, industrial logistics services Pune, industrial transport company Pune, industrial cargo transportation Pune, industrial freight transportation Pune, heavy equipment transportation Pune, heavy goods transport Pune, industrial transportation company Pune, industrial transportation services Pune, industrial goods transport Pune, industrial logistics Pune, industrial cargo transport Pune, industrial freight services Pune, machinery transportation Pune, equipment transportation Pune, factory goods transportation Pune, manufacturing transportation Pune, industrial material transport Pune, heavy cargo transportation Pune, heavy machinery transport Pune, bulky goods transportation Pune, commercial industrial transport Pune, industrial supply chain transportation Pune, warehouse to factory transport Pune, factory to warehouse transport Pune, project cargo transportation Pune, industrial goods logistics Pune, interstate industrial transportation Pune, Maharashtra industrial transport Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Transportserviceforindustries;